export default "__VITE_ASSET__795af921__"